import templateUrl from "./breadcrumb.html";

export const breadcrumbComponent = {
  templateUrl,
  controller: class Breadcrumb {
    constructor($state, $transitions, $stateParams, $window) {
      "ngInject";
      this.$stateParams = $stateParams;
      this.$window = $window;
      this.breadcrumbs = [];
      this.$state = $state;
      this.onStateChangeSuccess.call(this);
      $transitions.onSuccess({}, this.onStateChangeSuccess.bind(this));
    }
    getBreadcrumbsCache() {
      // this is the breadcrumb state stored in local storage
      // and useful when a user refresh the page
      // and the params will still be retained
      const breadcrumbsCache = this.$window.localStorage.getItem("breadcrumbs");
      return breadcrumbsCache ? JSON.parse(breadcrumbsCache) : [];
    }
    resetBreadcrumbsInCache(breadcrumbs) {
      this.$window.localStorage.setItem(
        "breadcrumbs",
        JSON.stringify(breadcrumbs)
      );
    }
    recurseBreadcrumbs() {
      let stateName = this.$state.current.name;
      let stateParams = this.$stateParams;
      const breadcrumbsCache = this.getBreadcrumbsCache();

      const breadcrumbs = [];
      // recurse through the state parentState
      // and build breadcrumbs
      while (stateName) {
        const stateDetails = this.$state.get(stateName);
        let breadcrumbDetails = {
          name: stateDetails.name,
          displayName: stateDetails.breadcrumbName,
          routeName: stateName,
          params: stateParams,
        };
        // ignore the state home
        // because it is statically added in breadcrumb html file
        // home is also the root route
        if (stateName !== "home") {
          breadcrumbs.unshift(breadcrumbDetails);
        }
        stateName = stateDetails.parentState;
        stateParams = null;
        if (stateName && breadcrumbsCache.length > 0) {
          // fetch breadcrumb params for this state
          const stateCache = breadcrumbsCache.find(
            ({ name }) => name === stateName
          );
          if (stateCache && stateCache.params) {
            stateParams = stateCache.params;
          } else {
            stateParams = null;
          }
        }
      }
      // reset the breadcrumb state in local storage
      this.resetBreadcrumbsInCache(breadcrumbs);
      return breadcrumbs;
    }
    onStateChangeSuccess() {
      const state = this.$state.current;
      if (state.name != "home" && state.parentState) {
        this.breadcrumbs = this.recurseBreadcrumbs();
      } else {
        this.breadcrumbs = [];
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/components/breadcrumb/breadcrumb.component.js